module.exports = __webpack_public_path__ + "static/a-xx-177-art-3be2bd2880cd6bacc48106ef78c933b7.jpg";